<template>
  <component :is="elementType" v-bind="attrs">
    {{ processedText }}
  </component>
</template>
<script setup lang="ts">
import capitalize from 'lodash/capitalize'
import { computed, useAttrs } from 'vue'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SfText',
})

interface Props {
  capitalized?: boolean
  elementType?: string
  text: string
}

const props = withDefaults(defineProps<Props>(), {
  elementType: 'span',
  text: '',
})

const attrs = useAttrs()

const processedText = computed<string>(() => {
  if (props.capitalized) {
    return capitalize(props.text)
  }

  return props.text
})
</script>
